// ============================================================================
// MONITOR ERROR BOUNDARY — Catches React render errors → MonitorEvent (v1.0)
// ============================================================================

import React from 'react';
import { addEvent } from '../services/MonitorEventStore';
import { Box, Typography, Button } from '@mui/material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';

class MonitorErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    addEvent({
      level: 'error',
      source: 'frontend',
      category: 'ui',
      action: 'REACT_RENDER_ERROR',
      message: `React error: ${error.message}`,
      data: {
        stack: error.stack,
        componentStack: errorInfo?.componentStack?.substring(0, 1000),
      },
    });
  }

  render() {
    if (this.state.hasError) {
      return (
        <Box sx={{
          p: 4, textAlign: 'center',
          background: 'linear-gradient(135deg, rgba(11,17,32,0.85) 0%, rgba(24,27,33,0.9) 100%)',
          borderRadius: 2, border: '1px solid rgba(239,68,68,0.3)', m: 2,
        }}>
          <ErrorOutlineIcon sx={{ fontSize: 48, color: '#EF4444', mb: 2 }} />
          <Typography sx={{ color: '#EF4444', fontWeight: 700, fontSize: '1.1rem', mb: 1 }}>
            Something went wrong
          </Typography>
          <Typography sx={{ color: '#9CA3AF', fontSize: '0.85rem', mb: 2 }}>
            {this.state.error?.message || 'An unexpected error occurred'}
          </Typography>
          <Button
            variant="outlined"
            size="small"
            onClick={() => this.setState({ hasError: false, error: null })}
            sx={{ color: '#00FF94', borderColor: 'rgba(0,255,148,0.3)', '&:hover': { borderColor: '#00FF94' } }}
          >
            Try Again
          </Button>
        </Box>
      );
    }
    return this.props.children;
  }
}

export default MonitorErrorBoundary;
